<template>
  <div>
    <select
      class="exp-select"
      v-model="value"
      :disabled="disabled"
      @input="
        $emit('input', $event.target.value),
          $emit('change', $event.target.value)
      "
    >
      <!--      <option selected="selected" :value="0">Не выбран</option>-->
      <option
        v-for="(option, index) in options"
        :value="option.value"
        :key="index + option.text"
      >
        {{ option.text }}
      </option>
    </select>
  </div>
</template>

<style>
.exp-select {
  margin: 10px 0px !important;
  font-size: 14px;
  width: 100%;
  height: 34px;
  padding: 0px 10px;
  border-radius: 5px;
  outline: none;
  border: none;
  box-sizing: border-box;
}
</style>
<script>
export default {
  name: "exp-select",
  props: {
    value: [String, Number],
    options: Array,
    select_title: String,
    disabled: Boolean
  },
  data() {
    return {
      currentOption: null
    };
  },
  mounted() {
    this.currentOption = this.value;
  }
};
</script>
